<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-ha`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38.043 24c2.407 0 4.195.677 5.354 2.042 1.005 1.193 1.511 2.914 1.511 5.133V41.81a1 1 0 01-1 1H42.47a1 1 0 01-1-1v-1.132a6.989 6.989 0 01-2.04 1.73c-1.111.584-2.387.886-3.805.886-1.602 0-2.893-.435-3.846-1.291l-.187-.177C30.53 40.856 30 39.585 30 38.023c0-2.084.748-3.708 2.223-4.817 1.317-1.05 3.194-1.595 5.629-1.666l3.401-.099v-.508c0-2.363-1.116-3.512-3.427-3.512-.993 0-1.794.2-2.38.592a2.79 2.79 0 00-1.099 1.354l-.043.124a1 1 0 01-1.05.7l-1.677-.16a1 1 0 01-.871-1.252l.028-.102c.448-1.506 1.266-2.666 2.428-3.432 1.191-.84 2.82-1.245 4.881-1.245zM5 5a1 1 0 011 1v16h17V6a1 1 0 011-1h2a1 1 0 011 1v36a1 1 0 01-1 1h-2a1 1 0 01-1-1V26H6v16a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h2zm36.253 30.36v-.809l-3.175.098c-2.895.066-4.299 1.154-4.299 3.235 0 .626.221 1.112.701 1.522.463.42 1.104.641 1.889.641 1.334 0 2.47-.455 3.436-1.365.958-.902 1.448-2.02 1.448-3.323z"/></svg>
</template>
<script>

export default {
  name: 'IconHa',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
